import { Injectable } from '@angular/core';
import { OpenWinLoadOption } from 'jk-service';
import { Observable } from 'rxjs';
import { StkmrServicePkg } from "./stkmrPkg.service";
import { Stkmr } from '../_entity_stk';

/**
 * 交易所基本資料
 */
@Injectable({
  providedIn: 'root'
})
export class StkmrService extends StkmrServicePkg {
  constructor() {
    super();
    this.getIdNameList();
  }
  getIdNameList() {
    let r: OpenWinLoadOption = {
      mainTable: 'STKMR',
      item: 'S01',
      type: 'S',
      params: [],
      list: this.idNameList,
    };
    this.orm.doOpenwinLoad(r);
    //return this.idNameList;
  }
  gotoKey(key: string): void {
    this.item = this.idNameList.find((item) => item.id === key);
  }
  getDay(stockno: string, account: string, uId: string): Observable<Stkmr[]> {
    let sql = `SELECT TOP 1 * FROM STKMR WHERE MR001='${stockno}' AND MR002='${account}' AND MR003='${uId}'  `;
    return this.simpleSqlRx(sql);
  }

}
